/**
 * ArtByPino: enforce custom.online_max_qty on Online Store cart add/change.
 * Shows a red "Limit N per order." message when the shopper tries to go over.
 * Does not run in Shopify Admin draft orders.
 */
(function () {
  function limitCopy(max) {
    return 'Limit ' + String(max) + ' per order.';
  }

  function revealCappedSelectors() {
    document.querySelectorAll('.quantity-selector-wrapper:has([data-abp-online-max-qty])').forEach((el) => {
      if (el instanceof HTMLElement) el.style.removeProperty('display');
    });
  }

  function harvest() {
    const variants = Object.assign({}, (window.ABP_ONLINE_MAX_QTY && window.ABP_ONLINE_MAX_QTY.variants) || {});
    const products = Object.assign({}, (window.ABP_ONLINE_MAX_QTY && window.ABP_ONLINE_MAX_QTY.products) || {});
    document.querySelectorAll('[data-abp-online-max-qty]').forEach((el) => {
      const max = parseInt(el.getAttribute('data-abp-online-max-qty'), 10);
      if (!max) return;
      const variantId =
        el.getAttribute('data-variant-id') || el.getAttribute('data-abp-variant-id');
      const productId = el.getAttribute('data-product-id');
      if (variantId) variants[String(variantId)] = max;
      if (productId) products[String(productId)] = max;
    });
    return { variants, products };
  }

  function maxFor(variantId, productId) {
    const maps = harvest();
    if (variantId && maps.variants[String(variantId)]) return maps.variants[String(variantId)];
    if (productId && maps.products[String(productId)]) return maps.products[String(productId)];
    return null;
  }

  function isCartSelector(el) {
    if (!el) return false;
    const tag = (el.tagName || '').toLowerCase();
    if (tag === 'cart-quantity-selector-component') return true;
    const input = el.querySelector && el.querySelector('input[type="number"]');
    return !!(input && (input.getAttribute('name') === 'updates[]' || input.hasAttribute('data-cart-line')));
  }

  function selectorInput(el) {
    if (!el || !el.querySelector) return null;
    return el.querySelector('input[ref="quantityInput"], input[type="number"]');
  }

  function capInfo(el) {
    if (!el) return null;
    const max = parseInt(el.getAttribute('data-abp-online-max-qty'), 10);
    if (!max) return null;
    const input = selectorInput(el);
    const cartQty = parseInt(input && input.getAttribute('data-cart-quantity'), 10) || 0;
    const value = parseInt(input && input.value, 10);
    const cart = isCartSelector(el);
    const effective = cart ? max : Math.max(max - cartQty, 0);
    return { max: max, effective: effective, cartQty: cartQty, value: value, cart: cart, input: input };
  }

  function ensureMsg(fromEl) {
    if (!fromEl) return null;
    const wrapper =
      fromEl.closest && fromEl.closest('.quantity-selector-wrapper')
        ? fromEl.closest('.quantity-selector-wrapper')
        : fromEl;
    let msg = wrapper.querySelector && wrapper.querySelector('[data-abp-qty-limit-msg]');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'abp-qty-limit-msg';
      msg.setAttribute('data-abp-qty-limit-msg', '');
      msg.setAttribute('role', 'status');
      msg.setAttribute('aria-live', 'polite');
      if (wrapper.appendChild) wrapper.appendChild(msg);
    }
    return msg;
  }

  function showAtcMsg(max) {
    const atc = document.querySelector('add-to-cart-component');
    if (!atc || !atc.parentElement) return;
    let msg = atc.parentElement.querySelector('[data-abp-atc-limit-msg]');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'abp-qty-limit-msg';
      msg.setAttribute('data-abp-atc-limit-msg', '');
      msg.setAttribute('role', 'status');
      msg.setAttribute('aria-live', 'polite');
      atc.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = limitCopy(max);
    msg.hidden = false;
    msg.classList.add('is-visible');
  }

  function showLimitMessage(fromEl, max, opts) {
    if (!max) return;
    const msg = ensureMsg(fromEl) || document.querySelector('[data-abp-qty-limit-msg]');
    if (msg) {
      msg.textContent = limitCopy(max);
      msg.hidden = false;
      msg.classList.add('is-visible');
    }
    if (opts && opts.atc) showAtcMsg(max);
    if (!fromEl && !(opts && opts.atc)) showAtcMsg(max);
  }

  function showLimitForVariant(variantId, productId, opts) {
    const max = maxFor(variantId, productId);
    if (!max) return;
    let el = null;
    if (variantId) {
      el = document.querySelector('[data-abp-online-max-qty][data-variant-id="' + variantId + '"]');
    }
    if (!el) el = document.querySelector('[data-abp-online-max-qty]');
    showLimitMessage(el, max, opts);
  }

  function plusButton(selector) {
    return selector.querySelector('button[name="plus"], .quantity-plus');
  }

  function eventHitsPlus(event, selector) {
    const plus = plusButton(selector);
    if (!plus) return false;
    if (event.target && event.target.closest && event.target.closest('button[name="plus"], .quantity-plus')) {
      return true;
    }
    const r = plus.getBoundingClientRect();
    return (
      event.clientX >= r.left &&
      event.clientX <= r.right &&
      event.clientY >= r.top &&
      event.clientY <= r.bottom
    );
  }

  function selectorFromEvent(event) {
    const direct =
      (event.target && event.target.closest && event.target.closest('[data-abp-online-max-qty]')) || null;
    if (direct) return direct;
    const wrapper = event.target && event.target.closest && event.target.closest('.quantity-selector-wrapper');
    if (wrapper) return wrapper.querySelector('[data-abp-online-max-qty]');
    const all = document.querySelectorAll('[data-abp-online-max-qty]');
    for (let i = 0; i < all.length; i++) {
      if (eventHitsPlus(event, all[i])) return all[i];
    }
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealCappedSelectors);
  } else {
    revealCappedSelectors();
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const selector = selectorFromEvent(event);
      if (!selector) return;
      const info = capInfo(selector);
      if (!info) return;
      if (!eventHitsPlus(event, selector)) return;
      if (info.effective <= 0 || (Number.isFinite(info.value) && info.value >= info.effective)) {
        showLimitMessage(selector, info.max, { atc: !info.cart });
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'number') return;
      const selector = input.closest('[data-abp-online-max-qty]');
      if (!selector) return;
      const info = capInfo(selector);
      if (!info) return;
      if (event.key === 'ArrowUp' && Number.isFinite(info.value) && info.value >= info.effective) {
        event.preventDefault();
        showLimitMessage(selector, info.max, { atc: !info.cart });
      }
    },
    true
  );

  function typedOverMax(input) {
    const selector = input.closest && input.closest('[data-abp-online-max-qty]');
    if (!selector) return;
    const info = capInfo(selector);
    if (!info) return;
    const typed = parseInt(input.value, 10);
    if (Number.isFinite(typed) && typed > info.effective) {
      showLimitMessage(selector, info.max, { atc: !info.cart });
    }
  }

  document.addEventListener(
    'input',
    function (event) {
      if (event.target instanceof HTMLInputElement) typedOverMax(event.target);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (event.target instanceof HTMLInputElement) typedOverMax(event.target);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const btn = event.target.closest && event.target.closest('button[name="add"], add-to-cart-component');
      if (!btn) return;
      const form = btn.closest('form');
      const selector =
        (form && form.querySelector('[data-abp-online-max-qty]')) ||
        document.querySelector('quantity-selector-component[data-abp-online-max-qty]');
      if (!selector) return;
      const info = capInfo(selector);
      if (!info) return;
      const variantInput = form && form.querySelector('[name="id"]');
      const variantId = variantInput && variantInput.value;
      const want = Number.isFinite(info.value) ? info.value : 1;
      if (info.cartQty + want > info.max || info.effective <= 0) {
        showLimitMessage(selector, info.max, { atc: true });
      } else if (variantId) {
        const max = maxFor(variantId, null);
        if (max && info.cartQty + want > max) showLimitMessage(selector, max, { atc: true });
      }
    },
    true
  );

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function cartPath(url) {
    try {
      const path = new URL(url, window.location.origin).pathname;
      if (/\/cart\/add(\.js)?$/.test(path)) return 'add';
      if (/\/cart\/change(\.js)?$/.test(path)) return 'change';
      if (/\/cart\/update(\.js)?$/.test(path)) return 'update';
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function parseBody(body) {
    if (!body) return { kind: 'empty' };
    if (body instanceof FormData) return { kind: 'form', data: body };
    if (body instanceof URLSearchParams) return { kind: 'params', data: body };
    if (typeof body === 'string') {
      const trimmed = body.trim();
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
          return { kind: 'json', data: JSON.parse(trimmed) };
        } catch (e) {
          return { kind: 'raw' };
        }
      }
      return { kind: 'params', data: new URLSearchParams(body) };
    }
    return { kind: 'raw' };
  }

  function getField(parsed, key) {
    if (parsed.kind === 'form' || parsed.kind === 'params') return parsed.data.get(key);
    if (parsed.kind === 'json' && parsed.data && typeof parsed.data === 'object') {
      if (parsed.data[key] != null) return parsed.data[key];
      if (Array.isArray(parsed.data.items) && parsed.data.items[0]) return parsed.data.items[0][key];
    }
    return null;
  }

  function setField(parsed, key, value) {
    if (parsed.kind === 'form' || parsed.kind === 'params') {
      parsed.data.set(key, String(value));
      return;
    }
    if (parsed.kind === 'json' && parsed.data && typeof parsed.data === 'object') {
      if (Array.isArray(parsed.data.items) && parsed.data.items[0]) {
        parsed.data.items[0][key] = value;
      } else {
        parsed.data[key] = value;
      }
    }
  }

  function serializeBody(parsed, original) {
    if (parsed.kind === 'form') return parsed.data;
    if (parsed.kind === 'params') {
      if (typeof original === 'string') return parsed.data.toString();
      return parsed.data;
    }
    if (parsed.kind === 'json') return JSON.stringify(parsed.data);
    return original;
  }

  async function cartState() {
    const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    return res.json();
  }

  function qtyInCart(cart, variantId) {
    let qty = 0;
    (cart.items || []).forEach((item) => {
      if (String(item.variant_id) === String(variantId) || String(item.id) === String(variantId)) {
        qty += Number(item.quantity) || 0;
      }
    });
    return qty;
  }

  function limitResponse(max) {
    const message = limitCopy(max || 2);
    return new Response(
      JSON.stringify({
        status: 422,
        message: 'Cart Error',
        description: message,
        errors: [message],
      }),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  }

  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = requestUrl(input);
    const action = cartPath(url);
    if (!action || (init && init.method && String(init.method).toUpperCase() === 'GET')) {
      return originalFetch.apply(this, arguments);
    }

    const parsed = parseBody(init && init.body);
    if (parsed.kind === 'empty' || parsed.kind === 'raw') {
      return originalFetch.apply(this, arguments);
    }

    const maps = harvest();
    const hasCaps = Object.keys(maps.variants).length > 0 || Object.keys(maps.products).length > 0;
    const rawId = getField(parsed, 'id');
    const productId = getField(parsed, 'product_id');
    const requested = parseInt(getField(parsed, 'quantity'), 10);
    const want = Number.isFinite(requested) ? requested : 1;

    if (action === 'add') {
      const max = maxFor(rawId, productId);
      if (!max || !rawId) return originalFetch.apply(this, arguments);
      const cart = await cartState();
      const remaining = max - qtyInCart(cart, rawId);
      if (remaining <= 0) {
        showLimitForVariant(rawId, productId, { atc: true });
        return limitResponse(max);
      }
      if (want > remaining) {
        showLimitForVariant(rawId, productId, { atc: true });
        setField(parsed, 'quantity', remaining);
      }
    } else if (action === 'change') {
      if (!hasCaps || !rawId) return originalFetch.apply(this, arguments);
      const cart = await cartState();
      let variantId = rawId;
      (cart.items || []).forEach((item) => {
        if (String(item.key) === String(rawId) || String(item.id) === String(rawId)) {
          variantId = item.variant_id;
        }
      });
      const max = maxFor(variantId, productId);
      if (!max) return originalFetch.apply(this, arguments);
      if (want > max) {
        showLimitForVariant(variantId, productId, { atc: false });
        setField(parsed, 'quantity', max);
      }
    } else {
      return originalFetch.apply(this, arguments);
    }

    const nextInit = Object.assign({}, init, { body: serializeBody(parsed, init && init.body) });
    return originalFetch.call(this, input, nextInit);
  };
})();
